var _path, _path2, _path3, _rect, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11035 2.87948C5.11035 2.39376 5.50411 2 5.98983 2H15.752L21.1168 7.7166V20.9967C21.1168 21.4824 20.7231 21.8762 20.2374 21.8762H5.98983C5.50411 21.8762 5.11035 21.4824 5.11035 20.9967V2.87948Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1172 7.71679V12.9937L15.8908 7.71679L21.1172 7.71679Z",
    fill: "#CAD1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 7.7166V2L21.1168 7.7166H15.752Z",
    fill: "#F15642"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.11035,
    y: 18.3584,
    width: 11.2573,
    height: 1.93485,
    fill: "#CAD1D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.8501,
    width: 13.3681,
    height: 7.21171,
    rx: 0.351791,
    fill: "#F15642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12982 17.7295V14.3523H6.3336C6.59635 14.3523 6.81402 14.4001 6.98662 14.4958C7.15921 14.5914 7.28839 14.7222 7.37413 14.8882C7.45988 15.0531 7.50276 15.2389 7.50276 15.4456C7.50276 15.6534 7.45933 15.8403 7.37249 16.0063C7.28674 16.1712 7.15701 16.302 6.98332 16.3987C6.81072 16.4944 6.5936 16.5422 6.33195 16.5422H5.50415V16.1102H6.28578C6.45178 16.1102 6.58645 16.0816 6.68979 16.0244C6.79313 15.9661 6.86899 15.887 6.91736 15.7869C6.96573 15.6869 6.98991 15.5731 6.98991 15.4456C6.98991 15.3181 6.96573 15.2048 6.91736 15.1059C6.86899 15.007 6.79258 14.9295 6.68814 14.8734C6.5848 14.8173 6.44848 14.7893 6.27919 14.7893H5.63937V17.7295H5.12982ZM9.19342 17.7295H8.10012V14.3523H9.22805C9.55895 14.3523 9.84313 14.4199 10.0806 14.5551C10.318 14.6892 10.5 14.8822 10.6264 15.1339C10.7539 15.3846 10.8177 15.6853 10.8177 16.0359C10.8177 16.3877 10.7534 16.6901 10.6248 16.9429C10.4972 17.1958 10.3126 17.3903 10.0707 17.5267C9.82884 17.6619 9.53641 17.7295 9.19342 17.7295ZM8.60966 17.2843H9.16538C9.42263 17.2843 9.63645 17.2359 9.80685 17.1391C9.97725 17.0413 10.1048 16.9 10.1894 16.7153C10.2741 16.5296 10.3164 16.3031 10.3164 16.0359C10.3164 15.771 10.2741 15.5462 10.1894 15.3615C10.1059 15.1768 9.9811 15.0366 9.8151 14.941C9.6491 14.8454 9.44297 14.7975 9.19671 14.7975H8.60966V17.2843ZM11.4513 17.7295V14.3523H13.5456V14.7909H11.9609V15.8199H13.3955V16.2569H11.9609V17.7295H11.4513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.0cb969e32ac1a1c9d98685f88a95a7ee.svg";
export { ForwardRef as ReactComponent };